import React, { useState } from 'react';
import '../styles/SideBarRight.css';
import useBuiltModalEscape from './useBuiltModalEscape';

export default function BuiltHomePhotoLightbox({ home, onClose = () => {} }) {
  const [photoAspectRatio, setPhotoAspectRatio] = useState(null);

  useBuiltModalEscape(Boolean(home?.photo), onClose);

  if (!home?.photo) return null;

  const title = home.clientName || home.address || 'Built home';

  return (
    <div
      className="built-pdf-lightbox-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={`Project photo for ${title}`}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="built-pdf-lightbox-panel built-photo-lightbox-panel">
        <div className="built-pdf-lightbox-header">
          <div>
            <div className="built-pdf-lightbox-title">Project Photo</div>
            <div className="built-pdf-lightbox-subtitle">{title}</div>
          </div>
          <div className="built-pdf-lightbox-actions">
            <a href={home.photo} target="_blank" rel="noreferrer">Open Image</a>
            <button type="button" onClick={onClose} aria-label="Close project photo">×</button>
          </div>
        </div>
        <div className="built-photo-lightbox-stage">
          <div
            className="built-photo-lightbox-frame"
            style={photoAspectRatio
              ? { '--built-photo-aspect-ratio': photoAspectRatio }
              : undefined}
          >
            <img
              src={home.photo}
              alt={title}
              onLoad={(event) => {
                const { naturalWidth, naturalHeight } = event.currentTarget;
                if (naturalWidth > 0 && naturalHeight > 0) {
                  setPhotoAspectRatio(naturalWidth / naturalHeight);
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
